// Guides pratiques ajoutés le 29 septembre 2026. Textes vérifiés sur Légifrance,
// Service Public et le site du Bureau central de tarification à cette date.
const L241_1 = { label: "Code des assurances, article L241-1 : obligation d’assurance et maintien de la garantie", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000031010281" };
const L243_2 = { label: "Code des assurances, article L243-2 : attestation jointe aux devis et factures", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000028748199" };
const L243_4 = { label: "Code des assurances, article L243-4 : saisine du Bureau central de tarification", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000006795920" };
const TITRE_IV = { label: "Code des assurances, articles L241-1 à L243-9 : assurance des travaux de construction (dont L243-3, sanctions)", url: "https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006073984/LEGISCTA000006142820/" };
const L113_12 = { label: "Code des assurances, article L113-12 : résiliation annuelle et préavis", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000038775154" };
const L113_14 = { label: "Code des assurances, article L113-14 : modes de notification de la résiliation", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000046194186" };
const L113_16 = { label: "Code des assurances, article L113-16 : résiliation après cessation d’activité", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000006792160" };
const SP_DECENNALE = { label: "Service Public : garantie décennale des constructeurs", url: "https://entreprendre.service-public.gouv.fr/vosdroits/F2034" };

export const GUIDE_CONTENT_2 = {
  "assurance-decennale-refusee-bct": {
    intro: "Si aucun assureur n’accepte de vous couvrir, la loi prévoit un recours : le Bureau central de tarification (BCT). Saisi dans les délais, il fixe la prime moyennant laquelle l’assureur qui vous a refusé est tenu de garantir votre responsabilité décennale. La procédure est formelle — lettre recommandée, délais courts, dossier complet — et se prépare dès la première demande d’assurance.",
    takeaways: [
      "Demandez l’assurance par lettre recommandée avec avis de réception : sans cette formalité, le refus ne pourra pas être porté devant le BCT.",
      "Le silence de l’assureur pendant plus de 45 jours vaut refus ; vous disposez ensuite de 15 jours pour saisir le BCT.",
      "Depuis la loi du 26 mai 2026, le refus doit mentionner la possibilité de saisir le BCT, qui statue dans un délai de trois mois.",
    ],
    sections: [
      {
        id: "role-bct",
        title: "Qu’est-ce que le Bureau central de tarification ?",
        paragraphs: [
          "Le BCT est un organisme créé par la loi pour les assurances obligatoires. En construction, l’article L243-4 du Code des assurances permet à toute personne soumise à l’obligation de s’assurer, qui essuie un refus de la part d’une entreprise d’assurance dont les statuts n’interdisent pas ce type de risque, de le saisir.",
          "Son rôle est limité : il fixe le montant de la prime moyennant laquelle l’assureur sollicité est tenu de garantir le risque qui lui a été proposé, et il peut déterminer une franchise restant à votre charge. Le BCT ne choisit pas un assureur à votre place et ne rédige pas un contrat sur mesure : il s’appuie sur la demande que vous avez adressée à un assureur précis.",
          "La loi n° 2026-403 du 26 mai 2026 de simplification de la vie économique a modifié l’article L243-4 : le refus de souscription doit désormais mentionner la possibilité de saisir le BCT et en préciser les modalités, et le BCT statue dans un délai de trois mois sur les demandes qui lui sont adressées.",
        ],
      },
      {
        id: "conditions",
        title: "Les conditions à remplir avant de saisir le BCT",
        paragraphs: [
          "Tout se joue avant le refus. L’article R250-2 du Code des assurances exige que la demande de souscription ait été adressée à l’assureur par lettre recommandée ou envoi recommandé électronique avec demande d’avis de réception, ou déposée contre récépissé. Un formulaire en ligne ou un échange téléphonique ne permet pas d’ouvrir ce recours.",
        ],
        items: [
          "Vos travaux sont soumis à l’obligation d’assurance décennale (article L241-1 du Code des assurances).",
          "Votre demande a été envoyée en recommandé avec avis de réception à un assureur qui pratique l’assurance construction.",
          "Vous avez reçu un refus écrit, ou l’assureur est resté silencieux plus de 45 jours après réception de la demande : en assurance construction, ce silence vaut refus.",
          "Vous saisissez le BCT dans les 15 jours qui suivent ce refus, sous peine d’irrecevabilité.",
        ],
      },
      {
        id: "dossier",
        title: "Constituer le dossier de saisine",
        paragraphs: [
          "Le site officiel du BCT met à disposition des questionnaires adaptés au profil du demandeur : artisan, entreprise générale, bureau d’études, etc. Il indique qu’ils sont à compléter et à envoyer par lettre recommandée avec avis de réception, accompagnés des justificatifs demandés. Téléchargez la version en vigueur sur le site du BCT au moment de votre démarche.",
        ],
        items: [
          "Le questionnaire du BCT correspondant à votre profil, complété et signé.",
          "La preuve de votre demande à l’assureur (copie du courrier et avis de réception) et, le cas échéant, sa lettre de refus.",
          "Votre dernier avis d’échéance si vous avez déjà été assuré.",
          "Si un courtier vous représente : la preuve d’un mandat spécial l’autorisant à agir pour vous.",
        ],
      },
      {
        id: "calendrier",
        title: "Un calendrier à anticiper",
        paragraphs: [
          "Exemple : votre demande envoyée en recommandé est reçue par l’assureur le 4 mars et reste sans réponse. Le refus implicite est acquis après plus de 45 jours de silence, soit vers le 19 avril ; le délai de 15 jours pour saisir le BCT court ensuite. Ajoutez le délai de décision du BCT, au plus trois mois depuis 2026, puis la mise en place du contrat : comptez plusieurs mois au total. En cas de doute sur le point de départ d’un délai, n’attendez pas le dernier jour.",
          "Pendant toute cette période, vous n’êtes pas assuré. N’ouvrez pas de chantier soumis à l’obligation décennale tant que la garantie n’a pas pris effet : la saisine du BCT ne vaut pas attestation d’assurance.",
        ],
      },
      {
        id: "avant-bct",
        title: "Avant d’en arriver là : les pistes à explorer",
        paragraphs: [
          "Un refus ne signifie pas que tout le marché refusera. Chaque assureur a ses propres critères : activités acceptées, expérience exigée, antécédents. Un courtier spécialisé peut présenter votre dossier à plusieurs compagnies et vous aider à identifier ce qui bloque.",
        ],
        items: [
          "Clarifiez vos activités : une activité à risque déclarée par précaution mais rarement exercée peut faire échouer un dossier. À l’inverse, n’omettez aucune activité réellement pratiquée.",
          "Rassemblez les preuves d’expérience : diplômes, certificats de travail, attestations d’anciens employeurs, factures et photos de chantiers.",
          "Expliquez vos antécédents : sinistres, résiliation, période sans assurance, et les mesures prises depuis.",
          "Conservez chaque refus par écrit : ils serviront si vous devez saisir le BCT.",
        ],
      },
    ],
    faq: [
      {
        q: "Le BCT m’assure-t-il directement ?",
        a: "Non. Le BCT fixe la prime, et éventuellement une franchise, moyennant laquelle l’assureur que vous avez sollicité est tenu de vous garantir. Le contrat est ensuite conclu avec cet assureur.",
      },
      {
        q: "Combien de refus faut-il avant de saisir le BCT ?",
        a: "Le texte vise le refus de l’entreprise d’assurance sollicitée : un refus suffit, à condition que la demande lui ait été adressée par recommandé avec avis de réception et qu’elle pratique ce type de risque.",
      },
      {
        q: "Puis-je travailler pendant la procédure ?",
        a: "Pas sur les chantiers soumis à l’obligation décennale tant que votre garantie n’a pas pris effet : l’article L241-1 du Code des assurances impose de justifier d’une assurance à l’ouverture du chantier.",
      },
      {
        q: "Le BCT peut-il m’imposer une franchise ?",
        a: "Oui. L’article L243-4 du Code des assurances lui permet de déterminer le montant d’une franchise qui reste à la charge de l’assuré.",
      },
      {
        q: "Mon assureur actuel résilie mon contrat : que faire ?",
        a: "Sollicitez rapidement d’autres assureurs par lettre recommandée avec avis de réception. En cas de refus, le recours au BCT est possible dans les mêmes conditions. Les chantiers ouverts pendant la validité de l’ancien contrat restent couverts par celui-ci pour la durée de la responsabilité décennale.",
      },
    ],
    sources: [
      L243_4,
      { label: "Code des assurances, articles R250-1 à R250-6 : procédure devant le Bureau central de tarification", url: "https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006073984/LEGISCTA000006143142/" },
      { label: "Bureau central de tarification : le BCT construction (questionnaires et pièces)", url: "https://www.bureaucentraldetarification.fr/le-bct-construction/" },
      L241_1,
    ],
    related: [
      { label: "Préparer un dossier en création d’entreprise", path: "/guide/decennale-creation-entreprise" },
      { label: "Changer d’assurance après une résiliation", path: "/guide/resilier-changer-assurance-decennale" },
      { label: "Faire étudier votre dossier", path: "/devis" },
    ],
  },

  "mention-decennale-devis-factures": {
    intro: "Deux textes s’appliquent aux artisans. Pour les travaux soumis à l’assurance décennale obligatoire, l’article L243-2 du Code des assurances impose de joindre l’attestation d’assurance à chaque devis et à chaque facture. Le Code de l’artisanat (article L132-1) impose par ailleurs d’indiquer l’assurance professionnelle obligatoire, les coordonnées de l’assureur et la couverture géographique — sauf pour les professionnels déjà visés par les articles L241-1 et L241-2 du Code des assurances. En pratique, joindre l’attestation et ajouter un encart clair évite toute ambiguïté.",
    takeaways: [
      "Travaux soumis à la décennale : joignez l’attestation d’assurance à chaque devis et à chaque facture (article L243-2).",
      "L’ancien article 22-2 de la loi du 5 juillet 1996 a été abrogé : la règle de mention figure depuis le 1er juillet 2023 à l’article L132-1 du Code de l’artisanat.",
      "Un encart récapitulatif (assureur, contrat, couverture géographique) facilite la lecture du client, mais ne remplace pas l’attestation.",
    ],
    sections: [
      {
        id: "attestation-jointe",
        title: "Décennale : l’attestation doit accompagner devis et factures",
        paragraphs: [
          "L’article L243-2 du Code des assurances prévoit que les professionnels soumis à l’obligation d’assurance décennale justifient de leur assurance par des attestations « jointes aux devis et factures des professionnels assurés ». Un arrêté fixe un modèle d’attestation comportant des mentions minimales : identité de l’assuré et de l’assureur, numéro de contrat, période de validité, activités garanties, notamment.",
          "Joignez l’attestation qui couvre la période d’ouverture du chantier et les activités du devis. Si votre devis comprend une prestation absente de l’attestation, faites vérifier votre couverture avant de l’envoyer : un client attentif comparera les deux documents.",
        ],
      },
      {
        id: "code-artisanat",
        title: "Les mentions prévues par le Code de l’artisanat",
        paragraphs: [
          "Depuis le 1er juillet 2023, l’article L132-1 du Code de l’artisanat, qui reprend l’ancien article 22-2 de la loi n° 96-603 du 5 juillet 1996, impose aux entreprises artisanales et aux micro-entrepreneurs d’indiquer sur chaque devis et chaque facture l’assurance professionnelle obligatoire souscrite, les coordonnées de l’assureur ou du garant et la couverture géographique du contrat.",
          "Le même article précise qu’il ne s’applique pas aux personnes mentionnées aux articles L241-1 et L241-2 du Code des assurances, c’est-à-dire notamment aux professionnels soumis à l’assurance décennale obligatoire, pour lesquels la justification passe par l’attestation jointe. Beaucoup d’artisans ont toutefois des activités mixtes, dont certaines ne relèvent pas de la décennale : joindre l’attestation et reprendre ces informations dans un encart ne présente aucun inconvénient.",
        ],
      },
      {
        id: "encart",
        title: "Que mettre dans l’encart assurance ?",
        paragraphs: [
          "Reprenez les informations à l’identique de votre attestation. N’ajoutez ni activité ni zone qui n’y figurent pas.",
        ],
        items: [
          "Le nom de l’assureur, c’est-à-dire la compagnie qui porte le risque, et, si vous le souhaitez, celui de votre intermédiaire.",
          "La nature des garanties et le numéro de contrat : responsabilité civile décennale, responsabilité civile professionnelle.",
          "Les coordonnées de l’assureur : adresse et, si possible, téléphone ou site internet.",
          "La couverture géographique indiquée dans le contrat, par exemple « France métropolitaine ».",
          "La période de validité de l’attestation jointe.",
        ],
      },
      {
        id: "generateur",
        title: "Générez votre encart assurance gratuitement",
        tool: "mention-generator",
        paragraphs: [
          "Renseignez les informations figurant sur votre attestation : le texte se met à jour et peut être copié dans votre logiciel de devis et de facturation. Aucune donnée n’est envoyée : tout reste dans votre navigateur.",
        ],
      },
      {
        id: "erreurs",
        title: "Les erreurs fréquentes",
        items: [
          "Joindre une attestation expirée, ou celle d’une autre période que celle de l’ouverture du chantier.",
          "Indiquer le nom de l’intermédiaire à la place de l’assureur qui porte le risque.",
          "Écrire « assuré décennale » sans préciser les activités, alors que le devis comporte des travaux non garantis.",
          "Modifier soi-même une attestation : seul l’assureur, ou son mandataire, peut établir ou corriger le document.",
        ],
        paragraphs: [
          "En cas de doute sur une activité, demandez une confirmation écrite à votre assureur avant d’envoyer le devis.",
        ],
      },
    ],
    faq: [
      {
        q: "L’encart remplace-t-il l’attestation ?",
        a: "Non. Pour les travaux soumis à l’assurance décennale obligatoire, l’article L243-2 du Code des assurances prévoit que l’attestation est jointe aux devis et factures. L’encart est un complément de lecture.",
      },
      {
        q: "Un micro-entrepreneur est-il concerné ?",
        a: "Oui. Le statut ne change rien : si vos travaux relèvent de la décennale, joignez l’attestation. L’article L132-1 du Code de l’artisanat vise d’ailleurs expressément les entrepreneurs relevant du régime micro-social.",
      },
      {
        q: "Mon attestation n’est pas encore émise : puis-je envoyer le devis ?",
        a: "Ne présentez pas des travaux comme assurés tant que vous ne disposez pas de l’attestation correspondante. Demandez à votre assureur ou à votre intermédiaire la date de prise d’effet et l’émission du document.",
      },
      {
        q: "Faut-il mentionner la RC Pro ?",
        a: "La RC Pro n’est pas légalement obligatoire pour la plupart des artisans du bâtiment ; lorsqu’elle est souscrite, la mentionner peut rassurer le client. Si votre métier est soumis à une autre assurance obligatoire, les mentions du Code de l’artisanat s’appliquent.",
      },
    ],
    sources: [
      L243_2,
      { label: "Code de l’artisanat, article L132-1 : assurance professionnelle sur les devis et factures", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000047362294" },
      { label: "Loi n° 96-603 du 5 juillet 1996, article 22-2 (abrogé au 1er juillet 2023)", url: "https://www.legifrance.gouv.fr/loda/article_lc/LEGIARTI000038587815" },
      { label: "Code des assurances, article A243-3 : mentions de l’attestation", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000031857550" },
    ],
    related: [
      { label: "Vérifier une attestation décennale", path: "/guide/verifier-attestation-decennale" },
      { label: "Obtenir son attestation", path: "/attestation" },
      { label: "Demander un devis d’assurance", path: "/devis" },
    ],
  },

  "travailler-sans-assurance-decennale": {
    intro: "Ouvrir un chantier soumis à l’obligation décennale sans être assuré expose à trois types de conséquences : une sanction pénale, le financement des réparations sur les fonds de l’entreprise pendant dix ans et, en société, la mise en cause possible du dirigeant sur son patrimoine personnel. Voici ce que prévoient les textes et comment se remettre en règle.",
    takeaways: [
      "Sanction pénale : jusqu’à six mois d’emprisonnement et 75 000 € d’amende (article L243-3 du Code des assurances).",
      "Sans assureur, les réparations des dommages de nature décennale restent à la charge de l’entreprise pendant dix ans après la réception.",
      "En société, le gérant qui ouvre sciemment un chantier sans assurance peut engager sa responsabilité personnelle (Cour de cassation, 28 septembre 2010).",
    ],
    sections: [
      {
        id: "obligation",
        title: "Quand l’assurance décennale est-elle obligatoire ?",
        paragraphs: [
          "L’article L241-1 du Code des assurances impose à toute personne dont la responsabilité décennale peut être engagée d’être couverte par une assurance, et d’en justifier à l’ouverture de chaque chantier. Le statut — micro-entreprise, entreprise individuelle ou société — ne change rien : c’est la nature des travaux qui compte.",
          "L’obligation s’apprécie chantier par chantier, à la date d’ouverture. Un contrat souscrit après le démarrage ne couvre pas un chantier déjà ouvert.",
        ],
      },
      {
        id: "sanction-penale",
        title: "La sanction pénale",
        paragraphs: [
          "L’article L243-3 du Code des assurances punit le défaut d’assurance obligatoire de six mois d’emprisonnement et de 75 000 € d’amende, ou de l’une de ces deux peines seulement. La seule exception prévue par le texte concerne la personne physique qui construit un logement pour l’occuper elle-même ou le faire occuper par sa proche famille : elle ne vise pas les professionnels.",
        ],
      },
      {
        id: "reparations",
        title: "Les réparations à vos frais pendant dix ans",
        paragraphs: [
          "La responsabilité décennale existe indépendamment de l’assurance : elle pèse sur le constructeur pendant dix ans à compter de la réception des travaux. Sans assureur, c’est l’entreprise — et donc sa trésorerie — qui doit financer la réparation des dommages relevant de cette garantie.",
          "Exemple : trois ans après la réception, une infiltration par la toiture rend une pièce inhabitable. Si le couvreur n’était pas assuré à l’ouverture du chantier, le coût de la reprise peut lui être réclamé directement par le client, ou par l’assureur dommages-ouvrage de ce dernier après indemnisation. Ce montant dépasse souvent de loin le prix d’une année d’assurance.",
        ],
      },
      {
        id: "dirigeant",
        title: "En société, le dirigeant n’est pas forcément protégé",
        paragraphs: [
          "Exercer en société ne met pas toujours le patrimoine du dirigeant à l’abri. Dans un arrêt du 28 septembre 2010 (n° 09-66.255), la chambre commerciale de la Cour de cassation a jugé que la gérante qui avait sciemment accepté d’ouvrir un chantier sans que la société soit couverte par l’assurance obligatoire avait commis une faute séparable de ses fonctions, engageant sa responsabilité personnelle envers les clients.",
        ],
      },
      {
        id: "commercial",
        title: "Les conséquences commerciales",
        paragraphs: [
          "Les clients avertis et les entreprises générales demandent l’attestation avant de signer ; elle doit d’ailleurs être jointe aux devis et factures (article L243-2 du Code des assurances). Sans elle, vous perdez des marchés, en particulier en sous-traitance, où le donneur d’ordre exige souvent une attestation couvrant votre intervention.",
        ],
      },
      {
        id: "regulariser",
        title: "Comment se remettre en règle",
        items: [
          "N’ouvrez plus de chantier soumis à l’obligation tant qu’aucun contrat n’a pris effet.",
          "Demandez une étude en déclarant exactement votre situation : durée sans assurance, chantiers réalisés pendant cette période, sinistres éventuels.",
          "Préparez vos justificatifs : Kbis ou avis de situation, diplômes, expérience, chiffre d’affaires.",
          "En cas de refus, envoyez vos demandes en recommandé avec avis de réception : le Bureau central de tarification pourra être saisi.",
        ],
        paragraphs: [
          "Un nouveau contrat ne couvre pas les chantiers ouverts pendant la période sans assurance. Ne dissimulez pas cette période à l’assureur : une fausse déclaration intentionnelle peut entraîner la nullité du contrat (article L113-8 du Code des assurances).",
        ],
      },
    ],
    faq: [
      {
        q: "Un auto-entrepreneur risque-t-il les mêmes sanctions ?",
        a: "Oui. L’article L243-3 s’applique à toute personne soumise à l’obligation d’assurance, quel que soit son statut. C’est la nature des travaux, et non le régime fiscal ou social, qui déclenche l’obligation.",
      },
      {
        q: "Peut-on souscrire une décennale avec effet rétroactif ?",
        a: "Ne comptez pas dessus : l’assurance obligatoire couvre les chantiers ouverts pendant la période de validité du contrat. Un chantier ouvert avant la prise d’effet n’est pas couvert par le nouveau contrat.",
      },
      {
        q: "Ma société est en liquidation : le client peut-il se retourner contre moi ?",
        a: "Si le chantier a été ouvert sans l’assurance obligatoire, la responsabilité personnelle du dirigeant peut être recherchée lorsque ce défaut d’assurance résulte d’une décision consciente, comme l’a jugé la Cour de cassation en 2010. Faites-vous conseiller par un avocat sur votre situation.",
      },
    ],
    sources: [
      TITRE_IV,
      { label: "Cour de cassation, chambre commerciale, 28 septembre 2010, n° 09-66.255 : responsabilité du gérant", url: "https://www.legifrance.gouv.fr/juri/id/JURITEXT000022879867/" },
      SP_DECENNALE,
      L243_2,
    ],
    related: [
      { label: "Assurance refusée : saisir le BCT", path: "/guide/assurance-decennale-refusee-bct" },
      { label: "Prix de l’assurance décennale par métier", path: "/prix" },
      { label: "Faire étudier votre dossier", path: "/devis" },
    ],
  },

  "parfait-achevement-biennale-decennale": {
    intro: "Après la réception des travaux, trois garanties légales se succèdent et se superposent : la garantie de parfait achèvement pendant un an, la garantie biennale de bon fonctionnement pendant au moins deux ans et la garantie décennale pendant dix ans. Elles ne couvrent pas les mêmes désordres et ne sont pas financées de la même manière. Les connaître aide l’artisan à répondre à une réclamation, et le client à la formuler au bon moment.",
    takeaways: [
      "Les trois garanties démarrent à la réception des travaux, qui doit donc être datée et formalisée.",
      "Parfait achèvement : l’entrepreneur répare tous les désordres signalés pendant un an ; ce n’est pas l’objet de l’assurance décennale.",
      "Décennale : dommages graves — solidité de l’ouvrage, impropriété à sa destination — couverts par l’assurance obligatoire du constructeur.",
    ],
    sections: [
      {
        id: "reception",
        title: "Tout part de la réception des travaux",
        paragraphs: [
          "La réception est l’acte par lequel le maître d’ouvrage accepte l’ouvrage, avec ou sans réserves (article 1792-6 du Code civil). Elle fait courir les délais des trois garanties. Un procès-verbal de réception daté et signé, qui liste les réserves éventuelles, évite les discussions ultérieures sur le point de départ.",
        ],
      },
      {
        id: "comparatif",
        title: "Les trois garanties en un coup d’œil",
        table: {
          caption: "Comparaison des garanties légales après réception des travaux",
          head: ["Garantie", "Durée", "Ce qu’elle vise", "Qui la finance"],
          rows: [
            ["Parfait achèvement (art. 1792-6)", "1 an", "Tous les désordres signalés, hors usure normale et mauvais usage", "L’entrepreneur"],
            ["Bon fonctionnement, dite biennale (art. 1792-3)", "2 ans au moins", "Éléments d’équipement dissociables de l’ouvrage", "Le constructeur ; certains contrats d’assurance l’incluent en garantie complémentaire"],
            ["Décennale (art. 1792 et 1792-4-1)", "10 ans", "Dommages compromettant la solidité ou rendant l’ouvrage impropre à sa destination", "L’assurance décennale obligatoire du constructeur"],
          ],
        },
        paragraphs: [
          "Ces garanties peuvent se cumuler : un désordre de gravité décennale apparu pendant la première année peut aussi relever de la garantie décennale.",
        ],
      },
      {
        id: "parfait-achevement",
        title: "La garantie de parfait achèvement : un an, tous les désordres signalés",
        paragraphs: [
          "Prévue à l’article 1792-6 du Code civil, elle oblige l’entrepreneur à réparer, pendant un an à compter de la réception, tous les désordres signalés par le maître d’ouvrage : réserves mentionnées au procès-verbal, ou désordres révélés ensuite et notifiés par écrit. Elle ne couvre ni l’usure normale ni les conséquences d’un mauvais usage.",
          "Cette garantie pèse sur l’entreprise elle-même : l’assurance décennale obligatoire n’a pas pour objet de financer la reprise des réserves. Prévoyez donc le temps et le budget nécessaires dans votre organisation.",
        ],
      },
      {
        id: "biennale",
        title: "La garantie biennale : deux ans pour les équipements dissociables",
        paragraphs: [
          "L’article 1792-3 du Code civil prévoit une garantie de bon fonctionnement d’au moins deux ans à compter de la réception pour les éléments d’équipement dissociables, c’est-à-dire ceux qui peuvent être enlevés ou remplacés sans détériorer l’ouvrage : selon leur mode de pose, certains radiateurs, appareils sanitaires ou moteurs de volets roulants.",
          "Pour un équipement ajouté ou remplacé sur un bâtiment existant sans constituer lui-même un ouvrage, la Cour de cassation juge depuis le 21 mars 2024 que les désordres relèvent de la responsabilité contractuelle de droit commun, et non des garanties décennale ou biennale.",
        ],
      },
      {
        id: "decennale",
        title: "La garantie décennale : dix ans pour les dommages graves",
        paragraphs: [
          "L’article 1792 du Code civil rend le constructeur responsable de plein droit des dommages qui compromettent la solidité de l’ouvrage ou qui, l’affectant dans l’un de ses éléments constitutifs ou d’équipement, le rendent impropre à sa destination. Cette responsabilité dure dix ans à compter de la réception (article 1792-4-1).",
          "C’est cette responsabilité que couvre l’assurance décennale obligatoire. Exemples typiques : fissures structurelles, infiltrations rendant un local inutilisable, affaissement d’un dallage, défaut d’une installation de chauffage intégrée rendant un logement inhabitable.",
        ],
      },
      {
        id: "faire-jouer",
        title: "Comment faire jouer ces garanties ?",
        paragraphs: [
          "Côté client : signalez le désordre par écrit à l’entreprise, de préférence par lettre recommandée avec avis de réception, avec photos et date d’apparition. Pour un dommage de nature décennale, contactez aussi l’assureur indiqué sur l’attestation de l’entreprise. Si vous avez souscrit une assurance dommages-ouvrage, déclarez-lui le sinistre : elle préfinance les réparations relevant de la décennale sans attendre la recherche des responsabilités.",
          "Côté artisan : ne laissez jamais une réclamation sans réponse. Pendant la première année, organisez la reprise des réserves. Pour un dommage susceptible de relever de la décennale, déclarez-le à votre assureur dans le délai prévu au contrat, et évitez de reconnaître votre responsabilité ou de promettre une indemnisation avant son avis.",
        ],
      },
    ],
    faq: [
      {
        q: "Une fissure est-elle couverte par la décennale ?",
        a: "Seulement si elle compromet la solidité de l’ouvrage ou le rend impropre à sa destination. Une microfissure esthétique relève plutôt, pendant la première année, de la garantie de parfait achèvement.",
      },
      {
        q: "La garantie de parfait achèvement est-elle assurée ?",
        a: "Elle incombe à l’entrepreneur. L’assurance décennale obligatoire couvre la responsabilité décennale, pas la reprise des réserves de la première année. Vérifiez les éventuelles garanties complémentaires de votre contrat.",
      },
      {
        q: "L’artisan a fermé son entreprise : puis-je encore agir ?",
        a: "Pour un dommage de nature décennale, l’assurance en vigueur à l’ouverture du chantier reste mobilisable pendant la durée de la responsabilité décennale. Contactez l’assureur figurant sur l’attestation remise avec le devis ou la facture.",
      },
    ],
    sources: [
      { label: "Code civil, article 1792-6 : réception et garantie de parfait achèvement", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000006443552" },
      SP_DECENNALE,
      { label: "Service Public : assurance dommages-ouvrage", url: "https://www.service-public.gouv.fr/particuliers/vosdroits/F2032" },
      { label: "Cour de cassation : équipements ajoutés ou remplacés sur un ouvrage existant (21 mars 2024)", url: "https://www.courdecassation.fr/decision/65fbeca2affbff00080c6bb5" },
    ],
    related: [
      { label: "Vérifier une attestation décennale", path: "/guide/verifier-attestation-decennale" },
      { label: "Comprendre l’assurance décennale", path: "/assurance-decennale" },
      { label: "Après la fermeture d’une entreprise", path: "/guide/decennale-cessation-activite" },
    ],
  },

  "decennale-cessation-activite": {
    intro: "Bonne nouvelle pour les artisans qui partent à la retraite ou ferment leur entreprise : l’assurance décennale fonctionne en « capitalisation ». Les chantiers ouverts pendant la validité du contrat restent garantis pendant toute la durée de la responsabilité décennale, même après la résiliation, sans prime supplémentaire. Inutile donc de continuer à payer pour les chantiers passés — à condition de conserver les bons documents.",
    takeaways: [
      "Tout contrat d’assurance décennale est réputé comporter une clause de maintien de la garantie pour la durée de la responsabilité décennale (article L241-1 du Code des assurances).",
      "C’est l’assureur en place à l’ouverture du chantier qui intervient, même des années après la fermeture de l’entreprise.",
      "En cas de cessation définitive, la résiliation est possible dans les trois mois suivant l’événement, avec effet un mois après sa notification (article L113-16).",
    ],
    sections: [
      {
        id: "capitalisation",
        title: "Le principe : la garantie suit le chantier, pas le contrat",
        paragraphs: [
          "L’article L241-1 du Code des assurances prévoit que tout contrat d’assurance décennale est, nonobstant toute stipulation contraire, réputé comporter une clause assurant le maintien de la garantie pour la durée de la responsabilité décennale. Les clauses types de l’annexe I à l’article A243-1 précisent que le contrat couvre les travaux ayant fait l’objet d’une ouverture de chantier pendant sa période de validité, et que la garantie est maintenue pour la même durée sans paiement de prime subséquente.",
          "Concrètement : un chantier ouvert en 2024, lorsque vous étiez assuré, reste couvert par ce contrat jusqu’à l’expiration de la responsabilité décennale, soit dix ans après la réception des travaux, même si vous résiliez le contrat en 2026.",
        ],
      },
      {
        id: "resilier",
        title: "Résilier le contrat quand vous arrêtez",
        paragraphs: [
          "L’article L113-16 du Code des assurances permet de résilier le contrat en cas de retraite professionnelle ou de cessation définitive d’activité, lorsqu’il garantit des risques liés à la situation antérieure qui ne se retrouvent pas dans la nouvelle. La résiliation doit intervenir dans les trois mois suivant l’événement et prend effet un mois après que l’assureur en a reçu notification.",
          "Vous pouvez aussi résilier à l’échéance annuelle en respectant un préavis de deux mois (article L113-12). Joignez un justificatif de cessation, par exemple l’attestation de radiation de l’entreprise, lorsque vous invoquez l’article L113-16.",
          "Attention : aucun nouveau chantier ne doit être ouvert après la date d’effet de la résiliation, puisqu’il ne serait plus couvert.",
        ],
      },
      {
        id: "documents",
        title: "Les documents à conserver",
        paragraphs: [
          "Si un client vous contacte des années plus tard, vous devrez retrouver le contrat en vigueur à l’ouverture de son chantier. Conservez ces pièces au moins dix ans après la réception du dernier chantier, et plus longtemps si un litige est en cours.",
        ],
        items: [
          "Les conditions générales et particulières de chaque contrat, avec leurs avenants.",
          "Les attestations annuelles, qui prouvent la période de validité et les activités garanties.",
          "Pour chaque chantier : devis, factures, date d’ouverture du chantier, procès-verbal de réception.",
          "Les coordonnées de l’assureur et le numéro de contrat, à transmettre au client qui vous signalerait un dommage.",
        ],
      },
      {
        id: "liquidation",
        title: "Liquidation judiciaire ou décès : les clients restent protégés",
        paragraphs: [
          "Si l’entreprise disparaît, la garantie reste attachée aux chantiers ouverts pendant la validité du contrat. Le client victime d’un dommage de nature décennale peut s’adresser directement à l’assureur de l’entreprise : l’article L124-3 du Code des assurances donne au tiers lésé un droit d’action directe contre l’assureur de responsabilité.",
          "D’où l’intérêt, pour le client, de conserver l’attestation d’assurance remise avec le devis ou la facture, et pour l’artisan, de la joindre systématiquement.",
        ],
      },
      {
        id: "transmission",
        title: "Vente ou transmission de l’entreprise",
        paragraphs: [
          "Les chantiers ouverts avant la transmission restent couverts par le contrat en vigueur à leur ouverture. Pour les chantiers ouverts ensuite, l’entreprise doit disposer d’une assurance en cours de validité. Selon la forme de la transmission — cession de parts sociales ou vente du fonds —, la situation du contrat diffère : faites-la examiner avec l’assureur avant la signature.",
        ],
      },
    ],
    faq: [
      {
        q: "Dois-je continuer à payer ma décennale après la retraite ?",
        a: "Non pour les chantiers passés : ils restent couverts par le contrat en vigueur à leur ouverture, sans prime supplémentaire. La résiliation empêche seulement de couvrir de nouveaux chantiers.",
      },
      {
        q: "Un ancien client me signale un dommage après la fermeture de mon entreprise : que faire ?",
        a: "Transmettez-lui les références de l’assureur et du contrat en vigueur à l’ouverture de son chantier, et déclarez le sinistre à cet assureur selon les modalités prévues au contrat.",
      },
      {
        q: "Et si je reprends une activité plus tard ?",
        a: "Souscrivez un nouveau contrat avant d’ouvrir un chantier soumis à l’obligation d’assurance, et signalez la période d’interruption à l’assureur lors de votre demande.",
      },
    ],
    sources: [
      L241_1,
      { label: "Code des assurances, annexe I à l’article A243-1 : clauses types de l’assurance décennale", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000021340467" },
      L113_16,
      { label: "Code des assurances, article L124-3 : action directe du tiers lésé", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000017735449" },
    ],
    related: [
      { label: "Résilier ou changer d’assurance décennale", path: "/guide/resilier-changer-assurance-decennale" },
      { label: "Les trois garanties après réception", path: "/guide/parfait-achevement-biennale-decennale" },
      { label: "Comprendre l’assurance décennale", path: "/assurance-decennale" },
    ],
  },

  "resilier-changer-assurance-decennale": {
    intro: "Changer d’assurance décennale est possible chaque année, à condition de tenir le calendrier : préavis, date d’effet du nouveau contrat, chantiers à venir. Grâce au fonctionnement en capitalisation, vos chantiers passés restent couverts par l’ancien contrat ; le véritable risque est d’ouvrir un chantier pendant un intervalle sans garantie.",
    takeaways: [
      "Résiliation à l’échéance annuelle : notifiez-la au moins deux mois avant la date d’échéance (article L113-12 du Code des assurances).",
      "Faites démarrer le nouveau contrat à la date où l’ancien prend fin : un chantier ouvert entre les deux ne serait pas couvert.",
      "Pour un contrat souscrit à des fins professionnelles, l’assureur peut lui aussi résilier à l’échéance annuelle, avec le même préavis.",
    ],
    sections: [
      {
        id: "echeance",
        title: "Résilier à l’échéance annuelle",
        paragraphs: [
          "L’article L113-12 du Code des assurances permet à l’assuré de résilier son contrat à l’expiration d’un délai d’un an, en adressant une notification à l’assureur au moins deux mois avant la date d’échéance. Le délai court à partir de la date du cachet de la poste ou de la date d’expédition de la notification.",
          "Retrouvez la date d’échéance sur vos conditions particulières ou votre dernier avis d’échéance. Exemple : pour une échéance au 1er janvier, la notification doit partir au plus tard le 1er novembre ; ne prenez pas de risque et envoyez-la plus tôt.",
        ],
      },
      {
        id: "notification",
        title: "Comment notifier la résiliation ?",
        paragraphs: [
          "L’article L113-14 permet de notifier la résiliation, au choix de l’assuré : par lettre ou tout autre support durable, par déclaration faite au siège social ou chez le représentant de l’assureur, par acte extrajudiciaire, par le même mode de communication à distance que celui utilisé pour la souscription, ou par tout autre moyen prévu par le contrat. L’assureur confirme par écrit la réception de la notification.",
          "Pour garder une preuve de la date d’envoi, privilégiez la lettre recommandée avec avis de réception ou l’envoi recommandé électronique.",
        ],
      },
      {
        id: "sans-trou",
        title: "Changer d’assureur sans trou de garantie",
        items: [
          "Demandez vos propositions deux à trois mois avant l’échéance, avec le même descriptif d’activités et votre historique de sinistres.",
          "Comparez les activités garanties, les franchises et les exclusions, pas seulement la prime.",
          "Faites fixer la date d’effet du nouveau contrat à la date de fin de l’ancien, puis envoyez votre résiliation.",
          "Récupérez la nouvelle attestation avant d’ouvrir le premier chantier qui suit le changement.",
        ],
        paragraphs: [
          "Les chantiers ouverts pendant la validité de l’ancien contrat restent couverts par lui pour la durée de la responsabilité décennale : le nouveau contrat n’a pas à les reprendre.",
        ],
      },
      {
        id: "resiliation-assureur",
        title: "Si c’est l’assureur qui résilie",
        paragraphs: [
          "Pour un contrat souscrit à des fins professionnelles, l’article L113-12 permet aussi à l’assureur de résilier à l’échéance annuelle, dans les mêmes conditions de préavis. Le contrat et le Code des assurances prévoient d’autres cas de résiliation, par exemple en cas de non-paiement de la prime.",
          "Réagissez dès la réception du courrier : sollicitez d’autres assureurs par lettre recommandée avec avis de réception. En cas de refus, cette formalité vous permettra de saisir le Bureau central de tarification dans les délais.",
        ],
      },
      {
        id: "changement-situation",
        title: "Cessation ou changement d’activité",
        paragraphs: [
          "L’article L113-16 prévoit une résiliation possible dans les trois mois suivant certains événements, dont la retraite professionnelle ou la cessation définitive d’activité, avec effet un mois après la notification. Si vous ajoutez ou retirez des activités sans cesser votre métier, un avenant suffit souvent : signalez tout changement à l’assureur avant les chantiers concernés.",
        ],
      },
    ],
    faq: [
      {
        q: "La loi Chatel ou la résiliation à tout moment s’appliquent-elles ?",
        a: "Non. Ces dispositifs visent les contrats couvrant des personnes physiques en dehors de leurs activités professionnelles. Pour une assurance décennale, référez-vous à l’échéance annuelle (article L113-12) et aux cas prévus par la loi et par votre contrat.",
      },
      {
        q: "Mes anciens chantiers sont-ils encore couverts après le changement ?",
        a: "Oui. Les chantiers ouverts pendant la validité de l’ancien contrat restent garantis par celui-ci pour la durée de la responsabilité décennale, même après sa résiliation.",
      },
      {
        q: "Puis-je changer d’assureur en cours d’année ?",
        a: "Pas librement : en dehors de l’échéance annuelle, la résiliation n’est possible que dans les cas prévus par la loi ou par votre contrat. Lisez vos conditions générales avant d’engager une démarche.",
      },
    ],
    sources: [L113_12, L113_14, L113_16, L241_1],
    related: [
      { label: "Assurance refusée : saisir le BCT", path: "/guide/assurance-decennale-refusee-bct" },
      { label: "Cessation d’activité et décennale", path: "/guide/decennale-cessation-activite" },
      { label: "Comparer des devis d’assurance", path: "/devis" },
    ],
  },
};
